import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

//Pages
import Home from "./Pages/Home/HomePage";
import Login from "./Pages/auth/LoginPage";
import SignUp from "./Pages/auth/RegisterPage";
import ResetPassword from "./Pages/Authentication/ResetPassword/ResetPassword";
import ResetPasswordSuccess from "./Pages/Authentication/ResetPasswordSuccess/ResetPasswordSuccess";
import SetNewPassword from "./Pages/Authentication/SetNewPassword/SetNewPassword";
// import University from "./Pages/University/University";

import Courses from "./Pages/Courses/Courses";
import Course from "./Pages/Course/Course";
import CareerPage from "./Pages/Career/CareerPage";
import Partners from "./Pages/Partners/Partners";
import LocalUniversitiesPage from "./Pages/LocalUniversitiesPage";
import OverseasUniversitiesPage from "./Pages/OverseasUniversitiesPage";
import LocalUniversitiesPageCN from "./Pages/LocalUniversitiesPageCN";
import OverseasUniversitiesPageCN from "./Pages/OverseasUniversityPageCN";
import CourseFinderPage from "./Pages/CourseFinder/CourseFinderPage";
import Universities from "./Pages/Universities/UniversitiesPage";
import UniversityDetails from "./Pages/University/UniversityDetails";
import CareerTestPage from "./Pages/CareerTest/CareerTestPage";
// import Universities from "./Pages/Universities/Universities";
import UEC2026 from "./Pages/UEC2026/UEC2026";
import SPM2026 from "./Pages/SPM2026/SPM2026Page";
import VerifySpmUpdatePage from "./Pages/SPM2026/VerifySpmUpdatePage";
import VerifyUecUpdatePage from "./Pages/UEC2026/VerifyUecUpdatePage";

//Dashboard
import DashboardLayout from "./Pages/Dashboard/DashboardLayout";
import DashboardHome from "./Pages/Dashboard/DashboardHome";
import ProfilePage from "./Pages/Dashboard/ProfilePage";
import ApplicationsPage from "./Pages/Dashboard/ApplicationsPage";
import ChatPage from "./Pages/Dashboard/ChatPage";
import RewardsPage from "./Pages/Dashboard/RewardsPage";
import DocumentsPage from "./Pages/Dashboard/DocumentsPage";
import ExplorePage from "./Pages/Dashboard/ExplorePage";
import UniversityDetailPage from "./Pages/Dashboard/UniversityDetailPage";
import CareerTestResultPage from "./Pages/Dashboard/CareerTestResultPage";
import CourseFinderResultPage from "./Pages/Dashboard/CourseFinderResultPage";
import ExamHubPage from "./Pages/Dashboard/ExamHubPage";
import ReferralPage from "./Pages/Dashboard/ReferralPage";

import { UniversityProvider } from "./context/UniversityContext";
import { CourseProvider } from "./context/CourseContext";
import { AuthProvider } from "./context/AuthContext";

import WhatsAppButton from "./Components/WhatsAppButton";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/reset-password-success"
            element={<ResetPasswordSuccess />}
          />
          <Route path="/set-new-password" element={<SetNewPassword />} />

          {/* Public Pages */}
          <Route path="/course-finder" element={<CourseFinderPage />} />
          <Route path="/career-test" element={<CareerTestPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/top-universities" element={<LocalUniversitiesPage />} />
          <Route
            path="/top-overseas-universities"
            element={<OverseasUniversitiesPage />}
          />

          <Route
            path="/top-universities-cn"
            element={<LocalUniversitiesPageCN />}
          />
          <Route
            path="/top-overseas-universities-cn"
            element={<OverseasUniversitiesPageCN />}
          />
          {/* Landing Page  */}
          <Route path="/uec-ultimate-revision-class" element={<UEC2026 />} />
          <Route path="/spm-ultimate-revision-class" element={<SPM2026 />} />
          <Route path="/verify-spm-update" element={<VerifySpmUpdatePage />} />
          <Route path="/verify-uec-update" element={<VerifyUecUpdatePage />} />

          {/* Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="applications" element={<ApplicationsPage />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="rewards" element={<RewardsPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="explore" element={<ExplorePage />} />
            <Route path="university/:slug" element={<UniversityDetailPage />} />
            <Route path="course-finder" element={<CourseFinderResultPage />} />
            <Route path="career-test" element={<CareerTestPage />} />
            <Route
              path="career-test-result"
              element={<CareerTestResultPage />}
            />
            <Route path="exam-hub" element={<ExamHubPage />} />
            <Route path="referral" element={<ReferralPage />} />
          </Route>

          <Route
            path="/*"
            element={
              <UniversityProvider>
                <CourseProvider>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                      path="/explore-universities"
                      element={<Universities />}
                    />
                    <Route
                      path="/university/:slug"
                      element={<UniversityDetails />}
                    />
                    <Route path="/courses" element={<Courses />} />
                    {/* <Route path="/courses/course" element={<Course />} /> */}
                    <Route path="/courses/:slug" element={<Course />} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </CourseProvider>
              </UniversityProvider>
            }
          />
        </Routes>
      </BrowserRouter>
      <WhatsAppButton />
    </AuthProvider>
  );
}

export default App;
